import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getDocuments } from 'src/app/home/adapters'
import {
  mapDocumentItem,
  type IDocumentOverviewEntity,
} from 'src/app/home/pages/overview/domain/use-cases/map-document-item'
import { documentsKeys } from 'src/app/home/queries/keys'

export interface IDocumentsQueryResult {
  items: IDocumentOverviewEntity[]
  total: number
  page: number
  pageSize: number
}

export interface IUseDocumentsQueryParams {
  page: number
  pageSize: number
  enabled: boolean
  silentErrorToast?: boolean
}

export const useDocumentsQuery = (
  params: IUseDocumentsQueryParams,
): UseQueryResult<IDocumentsQueryResult, Error> => {
  return useQuery({
    queryKey: documentsKeys.list({
      page: params.page,
      pageSize: params.pageSize,
    }),
    ...(params.silentErrorToast ? { meta: { silent: true } } : {}),
    queryFn: async (): Promise<IDocumentsQueryResult> => {
      const response = await getDocuments({
        page: params.page,
        pageSize: params.pageSize,
      })
      return {
        items: response.data.map(mapDocumentItem),
        total: response.total,
        page: response.page,
        pageSize: response.page_size,
      }
    },
    enabled: params.enabled,
  })
}
